module.exports = __webpack_public_path__ + "img/w3_add_light.5c620001.png";